import easydropdown from 'easydropdown-a11y'

const SELECTORS = Selectors({
  dropdown: 'js-dropdown',
  styledFormDropdown: 'styled-form select.dropdown'
})

const $dropdowns = document.querySelectorAll(SELECTORS.asClass('dropdown'))
const $styledFormDropdowns = document.querySelectorAll(SELECTORS.asClass('styledFormDropdown'))

const state = {
  dropdownMutationObserver: null
}

const fn = {
  init: () => {
    state.dropdownMutationObserver = new MutationObserver(fn.dropdownMutationCallback)

    $dropdowns.forEach($el => {
      if (!$el.querySelector('[selected]')) {
        $el.selectedIndex = -1
      }
    })

    $styledFormDropdowns.forEach($el => {
      if (document.body.classList.contains('pagetype-onlineapplicationformpage') ||
          document.body.classList.contains('pagetype-donatepage')) {
        return
      }

      const opts = {
        behavior: {
          openOnFocus: true,
          maxVisibleItems: 8
        },
        callbacks: {
          onSelect: () => {
            const $holder = $el.closest('.middleColumn')
            const $errorLabel = $holder ? $holder.querySelector('span.error') : null
            const $validationError = $el.closest('.field.dropdown.error')

            if ($errorLabel) {
              $errorLabel.remove()
            }

            if ($validationError) {
              $validationError.classList.remove('error')
            }
          }
        }
      }

      const $placeholder = $el.querySelector('option[value=""]')

      if ($placeholder && !$placeholder.hasAttribute('data-placeholder')) {
        $placeholder.setAttribute('data-placeholder', true)
        $placeholder.textContent = '(Select One)'
      }

      easydropdown($el, opts)

      const $fieldWrapper = $el.closest('.field-wrapper')

      //$fieldWrapper.querySelector('.edd-root').setAttribute('aria-labelledby', $fieldWrapper.id)
      //$fieldWrapper.querySelector('.edd-body').setAttribute('aria-labelledby', $fieldWrapper.id)

      if ($el.closest('form').classList.contains('userform')) {
        state.dropdownMutationObserver.observe($fieldWrapper, {
          attributes: false,
          childList: true,
          subtree: true
        })
      }
    })
  },

  // Fix for Userform's validation errors with easydropdown
  dropdownMutationCallback: (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type == 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.classList && node.classList.contains('error') && !node.classList.contains('error-fix')) {
            const $targetParent = node.closest('.middleColumn')

            if ($targetParent) {
              node.classList.add('error-fix')
              $targetParent.appendChild(node)
            }
          }
        })
      }
    }
  }
}

export default {
  can: () => $dropdowns.length || $styledFormDropdowns.length,
  run: fn.init
}
